// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1068":"0254092cb3cb337e","2564":"a930605a40aa8dc2","4681":"ac06817b38c65ea5","5535":"8ad56543f0acb5c7","8359":"96dfe845669fe639","9518":"97d4550235264389"}[chunkId] + ".css";
};